import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import { useSelector } from 'react-redux';

const theme1 = createTheme({
  palette: {
    primary: { main :'#f46a9f'},
    secondary: {
      main: '#ffebee',
    },
  },
  spacing: (factor) => `${8 * factor}px`,
  mixins: {
    toolbar: {
      minHeight: 56,
      '@media (min-width:0px) and (orientation: landscape)': {
        minHeight: 48,
      },
      '@media (min-width:600px)': {
        minHeight: 64,
      },
    },
  },
});


const theme2 = createTheme({
  palette: {
    primary: { main :'#3f51b5'},
    secondary: {
      main: '#f50057',
    },
  },
  spacing: (factor) => `${8 * factor}px`,
  mixins: {
    toolbar: {
      minHeight: 56,
      '@media (min-width:0px) and (orientation: landscape)': {
        minHeight: 48,
      },
      '@media (min-width:600px)': {
        minHeight: 64,
      },
    },
  },
});


const theme3 = createTheme({
  palette: {
    primary: { main :'#db3d00'},
    secondary: {
      main: '#ffd6bd',
    },
  },
  spacing: (factor) => `${8 * factor}px`,
  mixins: {
    toolbar: {
      minHeight: 56,
      '@media (min-width:0px) and (orientation: landscape)': {
        minHeight: 48,
      },
      '@media (min-width:600px)': {
        minHeight: 64,
      },
    },
  },
});


const theme4 = createTheme({
  palette: {
    primary: { main :'#FCCB00'},
    secondary: {
      main: '#ffd64e',
    },
  },
  spacing: (factor) => `${8 * factor}px`,
  mixins: {
    toolbar: {
      minHeight: 56,
      '@media (min-width:0px) and (orientation: landscape)': {
        minHeight: 48,
      },
      '@media (min-width:600px)': {
        minHeight: 64,
      },
    },
  },
});


const theme5 = createTheme({
  palette: {
    primary: { main :'#a8c17f'},
    secondary: {
      main: '#fce1d7',
    },
  },
  spacing: (factor) => `${8 * factor}px`,
  mixins: {
    toolbar: {
      minHeight: 56,
      '@media (min-width:0px) and (orientation: landscape)': {
        minHeight: 48,
      },
      '@media (min-width:600px)': {
        minHeight: 64,
      },
    },
  },
});


const theme6 = createTheme({
  palette: {
    primary: { main :'#1273de'},
    secondary: {
      main: '#c4e3fc',
    },
  },
  spacing: (factor) => `${8 * factor}px`,
  mixins: {
    toolbar: {
      minHeight: 56,
      '@media (min-width:0px) and (orientation: landscape)': {
        minHeight: 48,
      },
      '@media (min-width:600px)': {
        minHeight: 64,
      },
    },
  },
});


const theme7 = createTheme({
  palette: {
    primary: { main :'#c5b1ea'},
    secondary: {
      main: '#fcd9d9',
    },
  },
  spacing: (factor) => `${8 * factor}px`,
  mixins: {
    toolbar: {
      minHeight: 56,
      '@media (min-width:0px) and (orientation: landscape)': {
        minHeight: 48,
      },
      '@media (min-width:600px)': {
        minHeight: 64,
      },
    },
  },
});

const theme8 = createTheme({
  palette: {
    primary: { main :'#212121'},
    secondary: {
      main: '#ffca28',
    },
  },
  spacing: (factor) => `${8 * factor}px`,
  mixins: {
    toolbar: {
      minHeight: 56,
      '@media (min-width:0px) and (orientation: landscape)': {
        minHeight: 48,
      },
      '@media (min-width:600px)': {
        minHeight: 64,
      },
    },
  },
});

const theme9 = createTheme({
  palette: {
    primary: { main :'#fafafa'},
    secondary: {
      main: '#263238',
    },
  },
  spacing: (factor) => `${8 * factor}px`,
  mixins: {
    toolbar: {
      minHeight: 56,
      '@media (min-width:0px) and (orientation: landscape)': {
        minHeight: 48,
      },
      '@media (min-width:600px)': {
        minHeight: 64,
      },
    },
  },
});

const themeMapping = {'#db3e00': theme3, '#fccb00': theme4, 
'#a8c17f': theme5, '#1273de': theme6, '#c5b1ea': theme7, '#f46a9f': theme1, '#3f51b5': theme2, '#212121': theme8, '#fafafa': theme9};


const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: '100%',
    overflowX: 'hidden',
  },
  content: {
    width: '100%',
    maxWidth: '100%',
    overflowX: 'hidden',
  }
}));

const Online = props => {
  const { children } = props;

  const classes = useStyles();
  const restaurant = useSelector((state) => state.menu.restaurant);
  // console.log("restaurant", restaurant && restaurant.them,  restaurant && themeMapping[restaurant.themeColor.toLowerCase()]);

  return (
    <ThemeProvider theme={restaurant && restaurant.themeColor && themeMapping[restaurant.themeColor.toLowerCase()]  ? themeMapping[restaurant.themeColor.toLowerCase()] : theme1}>
    <div className={classes.root}>
      <main className={classes.content}>{children}</main>
    </div>
    </ThemeProvider>
  );
};

Online.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

export default Online;
